var map = {
	"./asset/asset.module": [
		"./src/app/views/settings/asset/asset.module.ts",
		"asset-asset-module"
	],
	"./building/building.module": [
		"./src/app/views/settings/building/building.module.ts",
		"building-building-module"
	],
	"./company/company.module": [
		"./src/app/views/settings/company/company.module.ts",
		"company-company-module"
	],
	"./views/application/application.module": [
		"./src/app/views/application/application.module.ts",
		"views-application-application-module"
	],
	"./views/dashboard/dashboard.module": [
		"./src/app/views/dashboard/dashboard.module.ts",
		"views-dashboard-dashboard-module~views-test-test-module",
		"views-dashboard-dashboard-module"
	],
	"./views/invoice/invoice.module": [
		"./src/app/views/invoice/invoice.module.ts",
		"views-invoice-invoice-module"
	],
	"./views/ppm/ppm.module": [
		"./src/app/views/ppm/ppm.module.ts",
		"views-ppm-ppm-module"
	],
	"./views/profile/profile.module": [
		"./src/app/views/profile/profile.module.ts",
		"views-profile-profile-module"
	],
	"./views/purchase-order/purchase-order.module": [
		"./src/app/views/purchase-order/purchase-order.module.ts",
		"views-purchase-order-purchase-order-module"
	],
	"./views/quotation/quotation.module": [
		"./src/app/views/quotation/quotation.module.ts",
		"views-quotation-quotation-module"
	],
	"./views/search/search.module": [
		"./src/app/views/search/search.module.ts",
		"views-search-search-module"
	],
	"./views/service/service.module": [
		"./src/app/views/service/service.module.ts",
		"views-service-service-module"
	],
	"./views/sessions/sessions.module": [
		"./src/app/views/sessions/sessions.module.ts",
		"views-sessions-sessions-module"
	],
	"./views/settings/settings.module": [
		"./src/app/views/settings/settings.module.ts",
		"views-settings-settings-module"
	],
	"./views/test/test.module": [
		"./src/app/views/test/test.module.ts",
		"views-dashboard-dashboard-module~views-test-test-module",
		"views-test-test-module"
	],
	"./views/timesheet/timesheet.module": [
		"./src/app/views/timesheet/timesheet.module.ts",
		"views-timesheet-timesheet-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;